export default __webpack_public_path__ + "abe3cd32af6b2d201f78cf85e6d4c665.svg";